import * as ChapterPartActions from "../actions/chapterPartActions";
import {addVideoQuestionTransformation, addQuizQuestionTransformation,
    deleteQuizQuestionTransformation, updateQuizQuestionTransformation,
    updateVideoQuestionsTransformation} from "../../utils/chapterDataTransformation";
import {ACTION_QUIZ_QUESTION_UPDATED} from "../actions/chapterPartActions";
import {NotificationManager} from 'react-notifications';
import api from '../../utils/api';

const questionTemplate = {
    question: '',
    optionA: '',
    optionB: '',
    optionC: '',
    optionD: '',
    correctOption: '',
    concept: '',
    image: ''
}

const sectionTemplate =  {name: '', subjectId: '', 
        questions: []
    };

const defaultState = {
    chapterPartInfo: {title: ''},
    video: {},
    thumbnail: {},
    banner: {},
    added: false,
    test: {
            title: '',
            show_description: '',
            type: '',
            instructions: '',
            course: '',
            courseId: '',
            subject: '',
            sections: [
                {name: '', subjectId: '', questions: []}
                
            ]
        },
    testTemplates: [],
    diagTestTemplates: []
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'DELETED_COURSE_TEST':
            return {
                ...state,
                testTemplates: state.testTemplates.filter(t => t.id !== action.payload)
            }
        case ChapterPartActions.RESET_TEST_TEMPLATE:
            return {
                ...state,
                test: defaultState.test
            }
        case ChapterPartActions.VIDEO_DELETED:
            return {
                ...state,
                chapterPartInfo: {
                    ...state.chapterPartInfo,
                    VideoFile: []
                }
            }
        case ChapterPartActions.VIDEO_UPLOADED:
            return {
                ...state,
                chapterPartInfo: state.chapterPartInfo.id === action.payload.chapterVideoId ? {
                    ...state.chapterPartInfo,
                    VideoFile: [action.payload]
                } : state.chapterPartInfo
            }
        case ChapterPartActions.CHAPTER_TEST_TEMPLATE_RETRIEVED:
            return {
                ...state,
                testTemplates: action.payload.mode === 'added' ? state.testTemplates.concat(action.payload.test) : state.testTemplates.map((t, i) => {
                    if(t.id === action.payload.test.id){
                        return action.payload.test
                    }else{
                        return t
                    }
                })
            };
            
        case ChapterPartActions.CHAPTER_TEST_TEMPLATES_RETRIEVED:
            return {
                ...state,
                testTemplates: action.payload
            };
        case ChapterPartActions.TEST_UPDATED:
            return {
                ...state,
                test: action.payload
            };
        case ChapterPartActions.UPLOADED_SECTION_FILE:
                return {
                    ...state,
                    test: {
                        ...state.test,
                        sections: state.test.sections.map((s, si) => {
                            if(si === action.payload.questionData.sectionIndex){
                                return {
                                    ...s,
                                    file: action.payload.image
                                }
                            }else{
                                return s
                            }
                        })
                    }
                };
                case ChapterPartActions.UPLOADED_FILE:
                    return {
                        ...state,
                        test: {
                            ...state.test,
                            sections: state.test.sections.map((s, si) => {
                                if(si === action.payload.questionData.sectionIndex){
                                    return {
                                        ...s,
                                        questions: s.questions.map((q, i) => {
                                            if(i === action.payload.questionData.index){
                                                return {
                                                    ...q,
                                                    image: action.payload.image
                                                }
                                            }else{
                                                return q
                                            }
                                        })
                                    }
                                }else{
                                    return s
                                }
                            })
                        }
                    };
                case ChapterPartActions.ADD_TEST_QUESTION:
                    return {
                        ...state,
                        test: {
                            ...state.test,
                            sections: state.test.sections.map((s, i) => {
                                if(i === action.payload.section){
                                    return {
                                        ...s,
                                        questions: s.questions.concat({
                                            ...questionTemplate,
                                            ...action.payload.partial
                                        })
                                    }
                                }else{
                                    return s
                                }
                            })
                        }
                    };

                case 'ADD_TEST_QUESTION_WITH_DATA':
                    return {
                        ...state,
                        test: {
                            ...state.test,
                            sections: state.test.sections.map((s, i) => {
                                if(i === action.payload.section){
                                    return {
                                        ...s,
                                        questions: s.questions.concat(action.payload.q)
                                    }
                                }else{
                                    return s
                                }
                            })
                        }
                    };
                case ChapterPartActions.TEST_DELETE_QUESTION:
                    return {
                        ...state,
                        test: {
                            ...state.test,
                            sections: state.test.sections.map((s, si) => {
                                if(si === action.payload.sectionIndex){
                                    return {
                                        ...s,
                                        questions: s.questions.filter((q, i) => i !== action.payload.index)
                                    }
                                }else{
                                    return s
                                }
                            })
                        }
                    };
                case ChapterPartActions.ADD_TEST_SECTION:
                    return {
                        ...state,
                        test: {
                            ...state.test,
                            sections: state.test.sections.concat(sectionTemplate)
                        }
                    };
                case ChapterPartActions.TEST_SECTION_UPDATED:
                    return {
                        ...state,
                        test: {
                            ...state.test,
                            sections: state.test.sections.map((s, i) => {
                                if(i === action.payload.index){
                                    return {
                                        ...s,
                                        [action.payload.field]: action.payload.value
                                    }
                                }else{
                                    return s
                                }
                            })
                        }
                    };
                case 'GOT_DIAG_TEMPLATES':
                    return {
                        ...state,
                        diagTestTemplates: action.payload
                    }
                case 'ADD_DIAG_TEST':
                    return {
                        ...state,
                        diagTestTemplates: state.diagTestTemplates.concat(action.payload)
                    }
                case ChapterPartActions.TEST_QUESTION_UPDATED:
                    return {
                        ...state,
                        test: {
                            ...state.test,
                            sections: state.test.sections.map((s, si) => {
                                if(si === action.payload.sectionIndex){
                                    return {
                                        ...s,
                                        questions: s.questions.map((q, i) => {
                                            if(i === action.payload.index){
                                                return {
                                                    ...q,
                                                    [action.payload.field]: action.payload.value
                                                }
                                            }else{
                                                return q
                                            }
                                        })
                                    }
                                }else{
                                    return s
                                }
                            })
                        }
                    }
        case ChapterPartActions.CHAPTER_TEST_RETRIEVED:
            return {
                ...state,
                test: action.payload,
                testTemplates: state.testTemplates.map(t => {
                    if(t.id === action.payload.id){
                        return {
                            ...t,
                            ...action.payload
                        }
                    }else{
                        return t
                    }
                })
            };
        case ChapterPartActions.ACTION_GET_CHAPTER_PART_INFO:
            return {
                ...state,
                chapterPartInfo: action.payload,
                thumbnail: action.payload.ChapterPartImage,
                banner: action.payload.ChapterPartBanner,
                added: false
            };
        case ChapterPartActions.ACTION_ADDED_CHAPTER_PART:
            return {
                ...state,
                chapterPartInfo: action.payload,
                video: {},
                thumbnail: action.payload.ChapterPartImage,
                banner: action.payload.ChapterPartBanner,
                added: true
            };
        case ChapterPartActions.ACTION_VIDEO_QUESTION_UPDATED:
            NotificationManager.success('Question has been saved.', 'Saved');
            return {
                ...state,
                chapterPartInfo: updateVideoQuestionsTransformation(state.chapterPartInfo, action.payload)
            }
        case ChapterPartActions.ACTION_IMAGE_ADDED:
            NotificationManager.success('Image uploaded successfully.', 'Saved');
            return {
                ...state,
                thumbnail: action.payload
            };
        case ChapterPartActions.ACTION_BANNER_ADDED:
            NotificationManager.success('Image uploaded successfully.', 'Saved');
            return {
                ...state,
                banner: action.payload
            };
        case ChapterPartActions.ACTION_LOAD_BLANK:
            return {
                ...state,
                added: false
            };
        case ChapterPartActions.ACTION_UPDATE_CHAPTER_PART_INFO:
            NotificationManager.success('Your lecture has been saved.', 'Saved');
            return {
                ...state,
                chapterPartInfo: {
                    ...state.chapterPartInfo,
                    ...action.payload
                }
            };
        case ChapterPartActions.ACTION_GOT_NEW_VIDEO:
            return {
                ...state,
                video: action.payload
            };
        case ChapterPartActions.ACTION_VIDEO_QUESTION_ADDED:
            NotificationManager.success('Video question saved.', 'Saved');
            return {
                ...state,
                chapterPartInfo: {
                    ...state.chapterPartInfo,
                    VideoQuestions: addVideoQuestionTransformation(state.chapterPartInfo, action.payload)
                }
            };
        case ChapterPartActions.ACTION_QUIZ_QUESTION_ADDED:
            NotificationManager.success('Quiz question saved.', 'Saved');
            return {
                ...state,
                chapterPartInfo: {
                    ...state.chapterPartInfo,
                    QuizQuestions:  state.chapterPartInfo.QuizQuestions.concat(action.payload).sort((a, b) => {
                        var a = a['number'],
                        b = b['number'];

                    if (a < b) {
                        return -1;
                    }else if (a > b) {
                        return 1;
                    } else {
                        return 0;
                    }
                    })//addQuizQuestionTransformation(state.chapterPartInfo, action.payload)
                }
            };
        case ChapterPartActions.ACTION_VIDEO_QUESTION_DELETED:
            return {
                ...state,
                chapterPartInfo: {
                    ...state.chapterPartInfo,
                    VideoQuestions: state.chapterPartInfo.VideoQuestions.filter(v => v.id !== action.payload)
                }
            };
        case ChapterPartActions.ACTION_QUIZ_QUESTION_DELETED:
            NotificationManager.success('Question has been successfully removed from this lecture', 'Deleted');
            return {
                ...state,
                chapterPartInfo: {
                    ...state.chapterPartInfo,
                    QuizQuestions: state.chapterPartInfo.QuizQuestions.filter(q => q.id !== action.payload)
                }
            };
        case ChapterPartActions.ACTION_QUIZ_QUESTION_UPDATED:
            NotificationManager.success('Quiz question has been saved.', 'Saved');
            return {
                ...state,
                chapterPartInfo: {
                    ...state.chapterPartInfo,
                    QuizQuestions: state.chapterPartInfo.QuizQuestions.map(q => {
                        if(q.id === action.payload.id){
                            return action.payload;
                        }else{
                            return q;
                        }
                    }) //updateQuizQuestionTransformation(state.chapterPartInfo, action.payload)
                }
            }
        default:
            return {
                ...state
            };
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/chapterPartReducer.js